import { createActionGroup, props } from '@ngrx/store';

import { ErrorModel } from '@rocksoft/shared';

import { AppleDeviceProfileEntry, AppleDeviceProfileType } from './apple-device-profile.types';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AppleDeviceProfileResolverActions = createActionGroup({
  source: 'Apple Device Profile Resolver',
  events: {
    'Profile requested': props<{ udid: string; profileType: AppleDeviceProfileType }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AppleDeviceProfileApiActions = createActionGroup({
  source: 'Apple Device Profile API',
  events: {
    'Profile loaded': props<{ entries: AppleDeviceProfileEntry[] }>(),
    'Profile loaded error': props<{ udid: string; profileType: AppleDeviceProfileType; error: ErrorModel }>(),
  },
});
